export enum MbsType {
  primary = 'primary',
  secondary = 'secondary',
  success = 'success',
  info = 'info',
  warning = 'warning',
  danger = 'danger',
  dark = 'dark',
  light = 'light',
  brand = 'brand',
  muted = 'muted',
  disabled = 'disabled'
}
